export default function DateRangeLowerThanDirective($filter, utilitySevice) {
	'ngInject';

	return {
		require: 'ngModel',
		link: function(scope, elm, attrs, ctrl) {
			var validateDateRange = function(inputValue) {
				var fromDate = $filter('date')(inputValue, 'short');
				var toDate = $filter('date')(attrs.dateRangeLowerThan, 'short');
				var isValid = utilitySevice.isValidMinDateRange(fromDate, toDate);
				ctrl.$setValidity('dateRangeLowerThan', isValid);
				return inputValue;
			};

			ctrl.$parsers.unshift(validateDateRange);
			ctrl.$formatters.push(validateDateRange);
			attrs.$observe('dateRangeLowerThan', function() {
				validateDateRange(ctrl.$viewValue);
			});
		}
	};
}
